import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { loading, groupEnumData, enumData, userPrefPageSize } from "@/decorators";
import BulkSearchModal from '@/views/components/bulkSearchModal/index.vue';
import DetailModal from '../complianceOfficer/detailModal.vue';
import chooseExportField from '@/components/chooseExportField';
import LogModal from "./components/logModal.vue";
import GPSRInfoMantenanceDetailModal from "./components/GPSRInfoDetailModal.vue";
import util from "@/utils/util";
var logModal = util.mountVueComponent(LogModal);
var viewGPSRInfoMantenanceModal = util.mountVueComponent(GPSRInfoMantenanceDetailModal);

var ProductGpsrInfoMantenanceList = function (_super) {
  __extends(ProductGpsrInfoMantenanceList, _super);

  function ProductGpsrInfoMantenanceList() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.boolEnumList = [];
    _this.dataList = [];
    _this.tableCount = [];
    _this.total = 0;
    _this.columns = [];
    _this.code_value_str = '';
    _this.loadingStatus = false;
    _this.multipleSelection = [];
    _this.searchData = _this.initSearchData();
    _this.lastParams = {};
    _this.rowData = {
      id: undefined,
      type: '',
      title: ''
    };
    _this.detailVisible = false;
    _this.maintenanceProductFieldEnum = [];
    _this.GpsrExportGroupFiledEnum = [];
    _this.auditStatusEnum = [];
    _this.productNameLangEnum = [];
    _this.agentNameTypeEnum = [];
    _this.labelSourceEnum = [];
    _this.productCategoryOptions = [];
    return _this;
  }

  Object.defineProperty(ProductGpsrInfoMantenanceList.prototype, "booleanEnumOptions", {
    get: function get() {
      if (this.boolEnumList) {
        var enumList = this.$util.deepCopy(this.boolEnumList);
        enumList.sort(function (a, b) {
          return b.value - a.value;
        });
        return enumList;
      }

      return [];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ProductGpsrInfoMantenanceList.prototype, "GPSrStatusOptins", {
    get: function get() {
      return this.$util.mergeCountDataToStatusEnum(this.auditStatusEnum, this.tableCount);
    },
    enumerable: false,
    configurable: true
  });

  ProductGpsrInfoMantenanceList.prototype.initSearchData = function () {
    return {
      audit_status: this.$enum.product.MaintenanceProductStatusEnum.ALL,
      code_type: this.$enum.product.MaintenanceProductFieldEnum.PRODUCT_SKU,
      code_value_list: [],
      product_name_type: this.$enum.product.ProductNameLangEnum.PRODUCT_CN,
      product_name_value: undefined,
      category_id: undefined,
      is_gpsr: undefined,
      compliance_leader_type: undefined,
      company_and_manufacturer: undefined,
      label_source: undefined,
      page_index: 1,
      page_size: 10
    };
  };

  ProductGpsrInfoMantenanceList.prototype.complianceLeaderTypeText = function (row) {
    return row.compliance_leader_type_text ? "\u3010" + row.compliance_leader_type_text + "\u3011" : '';
  };

  ProductGpsrInfoMantenanceList.prototype.queryProductCategoryOptions = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.product.queryProductCateList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.productCategoryOptions = data.map(function (item) {
              return {
                label: item.category_name,
                value: item.category_id
              };
            });
            return [2];
        }
      });
    });
  };

  ProductGpsrInfoMantenanceList.prototype.updateSearchList = function () {
    this.queryTableList();
  };

  ProductGpsrInfoMantenanceList.prototype.created = function () {
    this.queryProductCategoryOptions();
    this.queryTableList();
    this.columns = [{
      title: this.t("商品编码"),
      dataIndex: "product_sku",
      filterEmpty: true,
      isCopy: true,
      scopedSlots: {
        customRender: "product_sku"
      }
    }, {
      title: this.t("谷仓商品条码"),
      dataIndex: "product_barcode",
      name: "product_barcode",
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t("参考编码"),
      dataIndex: "product_reference_number",
      name: "product_reference_number",
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t("中文名称"),
      dataIndex: "product_name_cn",
      name: "product_name_cn",
      filterEmpty: true
    }, {
      title: this.t("英文名称"),
      dataIndex: "product_name_en",
      name: "product_name_en",
      filterEmpty: true
    }, {
      title: this.t("商品品类"),
      dataIndex: "category_name",
      name: "category_name",
      filterEmpty: true
    }, {
      title: this.t("是否GPSR产品"),
      dataIndex: "is_gpsr_text",
      name: "is_gpsr_text",
      filterEmpty: true
    }, {
      title: this.t("合规负责人编码"),
      dataIndex: "officer_no",
      name: "officer_no",
      filterEmpty: true
    }, {
      title: this.t("合规负责人类型"),
      dataIndex: "compliance_leader_type_text",
      name: "compliance_leader_type_text",
      filterEmpty: true
    }, {
      title: this.t("GPSR标签来源"),
      dataIndex: "label_source_text",
      name: "label_source_text",
      filterEmpty: true
    }, {
      title: this.t("公司信息"),
      dataIndex: "company_info",
      name: "company_info",
      width: 250,
      filterEmpty: true,
      scopedSlots: {
        customRender: "company_info"
      }
    }, {
      title: this.t("制造商信息"),
      dataIndex: "manufacturer_info",
      name: "manufacturer_info",
      width: 250,
      filterEmpty: true,
      scopedSlots: {
        customRender: "manufacturer_info"
      }
    }, {
      title: this.t("状态"),
      dataIndex: "audit_status_text",
      name: "audit_status_text",
      width: 90,
      filterEmpty: true,
      scopedSlots: {
        customRender: "audit_status_text"
      }
    }, {
      title: this.t("时间"),
      dataIndex: "time",
      name: "time",
      width: 220,
      filterEmpty: true,
      scopedSlots: {
        customRender: "time"
      }
    }, {
      title: this.t("操作"),
      key: 'operation',
      showColumnSetting: true,
      fixed: 'right',
      width: 170,
      scopedSlots: {
        customRender: "operation"
      }
    }];
  };

  ProductGpsrInfoMantenanceList.prototype.queryTableList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, data, code;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = this.searchData;
            this.lastParams = this.$util.deepCopy(postData);
            return [4, this.$api.product.queryTableList(postData)];

          case 1:
            _a = _b.sent(), data = _a.data, code = _a.code;

            if (!code) {
              this.dataList = data.list.map(function (item) {
                item.id = item.product_sku + ":" + item.officer_no;
                return item;
              });
              this.total = data.total;
            }

            this.queryTableDataCount();
            return [2];
        }
      });
    });
  };

  ProductGpsrInfoMantenanceList.prototype.queryTableDataCount = function () {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, data, code;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = this.searchData;
            this.lastParams = this.$util.deepCopy(postData);
            return [4, this.$api.product.getGPSRDataCount(postData)];

          case 1:
            _a = _b.sent(), data = _a.data, code = _a.code;

            if (!code) {
              this.tableCount = data;
            }

            return [2];
        }
      });
    });
  };

  ProductGpsrInfoMantenanceList.prototype.handleDblClick = function () {
    var bulkSearchModal = this.$refs.bulkSearchModal;
    bulkSearchModal.modalVisible = true;
    bulkSearchModal.bulkListStr = this.code_value_str;
  };

  ProductGpsrInfoMantenanceList.prototype.handleBulkFeedback = function (bulkKeywords) {
    this.code_value_str = bulkKeywords;
  };

  ProductGpsrInfoMantenanceList.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.multipleSelection = [];
    this.queryTableList();
  };

  ProductGpsrInfoMantenanceList.prototype.handleSearch = function () {
    this.searchData.code_value_list = this.code_value_str.split(',').filter(function (item) {
      return item;
    });
    this.multipleSelection.length = 0;
    this.searchData.page_index = 1;
    this.queryTableList();
  };

  ProductGpsrInfoMantenanceList.prototype.handleReset = function () {
    this.code_value_str = '';
    this.searchData = this.initSearchData();
    this.queryTableList();
  };

  ProductGpsrInfoMantenanceList.prototype.handleBatchAdd = function () {
    this.$router.push({
      path: "maintenance_compliance_officer/add"
    });
  };

  ProductGpsrInfoMantenanceList.prototype.handleAdd = function () {
    this.$router.push({
      path: "maintenance_compliance_officer/add"
    });
  };

  ProductGpsrInfoMantenanceList.prototype.handleUpdate = function (record, path) {
    this.$router.push({
      path: path,
      query: {
        officer_no: record.officer_no,
        product_sku: record.product_sku
      }
    });
  };

  ProductGpsrInfoMantenanceList.prototype.handleViewDetail = function (record) {
    viewGPSRInfoMantenanceModal({
      parent: this,
      propsData: {
        record: record
      }
    });
  };

  ProductGpsrInfoMantenanceList.prototype.handleLog = function (record) {
    logModal({
      parent: this,
      propsData: {
        record: record
      }
    });
  };

  ProductGpsrInfoMantenanceList.prototype.handleComplianceLeaderDetail = function (record) {
    this.rowData.id = record.compliance_officer_id;
    this.detailVisible = true;
  };

  ProductGpsrInfoMantenanceList.prototype.onSelectChange = function (selectedRowKeys) {
    this.multipleSelection = selectedRowKeys;
  };

  ProductGpsrInfoMantenanceList.prototype.exportData = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.product.exportGPSR(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$util.exportExcel(res.data);
            }

            return [2];
        }
      });
    });
  };

  ProductGpsrInfoMantenanceList.prototype.handleExportAll = function () {
    var _this = this;

    chooseExportField({
      name: 'maintenanceComponplianceOffcer',
      data: this.GpsrExportGroupFiledEnum,
      selectType: this.$enum.common.ChooseExportFieldTypeEnum.TWOSELECT,
      onOk: function onOk(data) {
        var searchData = _this.$util.deepCopy(_this.searchData);

        delete searchData.page_index;
        delete searchData.page_size;

        if (searchData.audit_status === _this.$enum.product.MaintenanceProductStatusEnum.ALL) {
          searchData.audit_status = null;
        }

        var params = Object.assign(searchData, {
          export_field_list: data
        });

        _this.exportData(params);
      }
    });
  };

  ProductGpsrInfoMantenanceList.prototype.handleExportSelected = function () {
    var _this = this;

    if (!this.multipleSelection.length) {
      this.$message.warn(this.tc(this.$config.exportSelectedEmptyTip));
      return;
    }

    chooseExportField({
      name: 'maintenanceComponplianceOffcer',
      data: this.GpsrExportGroupFiledEnum,
      selectType: this.$enum.common.ChooseExportFieldTypeEnum.TWOSELECT,
      onOk: function onOk(data) {
        var params = __assign(__assign({
          export_field_list: data
        }, _this.searchData), {
          code_value_list: _this.multipleSelection.map(function (item) {
            return item.split(':')[0];
          }),
          officer_no_list: _this.multipleSelection.map(function (item) {
            return item.split(':')[1];
          })
        });

        _this.exportData(params);
      }
    });
  };

  __decorate([enumData('BoolIntEnum')], ProductGpsrInfoMantenanceList.prototype, "boolEnumList", void 0);

  __decorate([enumData('EuroAgents/MaintenanceProductFieldEnum')], ProductGpsrInfoMantenanceList.prototype, "maintenanceProductFieldEnum", void 0);

  __decorate([groupEnumData('Gpsr/GpsrExportGroupFiledEnum')], ProductGpsrInfoMantenanceList.prototype, "GpsrExportGroupFiledEnum", void 0);

  __decorate([enumData("Gpsr/AuditStatusEnum")], ProductGpsrInfoMantenanceList.prototype, "auditStatusEnum", void 0);

  __decorate([enumData('EuroAgents/ProductNameLangEnum')], ProductGpsrInfoMantenanceList.prototype, "productNameLangEnum", void 0);

  __decorate([enumData('EuroAgents/AgentNameTypeEnum')], ProductGpsrInfoMantenanceList.prototype, "agentNameTypeEnum", void 0);

  __decorate([enumData("Gpsr/LabelSourceEnum")], ProductGpsrInfoMantenanceList.prototype, "labelSourceEnum", void 0);

  __decorate([userPrefPageSize("tariffBillingList")], ProductGpsrInfoMantenanceList.prototype, "initSearchData", null);

  __decorate([loading("loadingStatus")], ProductGpsrInfoMantenanceList.prototype, "queryTableList", null);

  ProductGpsrInfoMantenanceList = __decorate([Component({
    components: {
      BulkSearchModal: BulkSearchModal,
      DetailModal: DetailModal
    }
  })], ProductGpsrInfoMantenanceList);
  return ProductGpsrInfoMantenanceList;
}(Vue);

export default ProductGpsrInfoMantenanceList;